module.exports = __webpack_public_path__ + "img/0Q3A2361_L_WoodMatted.2251ca91.jpg";